"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRefundAmount = validateRefundAmount;
exports.validateLineQuantity = validateLineQuantity;
exports.validateLinePrice = validateLinePrice;
exports.validateLinePriceTotal = validateLinePriceTotal;
exports.validateAllRefundItems = validateAllRefundItems;
const refundHelpers_1 = require("./refundHelpers");
function validateRefundAmount(refundTotal, originalTotal) {
    if (refundTotal > originalTotal) {
        return 'refundExceedsOrderTotal';
    }
    return undefined;
}
function validateLineQuantity(returnedAmount, originalAmount, aisleCode) {
    if (returnedAmount > originalAmount) {
        return 'quantityExceedsOriginal';
    }
    return undefined;
}
function validateLinePrice(returnedPrice, originalPrice) {
    if (returnedPrice > originalPrice) {
        return 'priceExceedsOriginal';
    }
    return undefined;
}
function validateLinePriceTotal(returnedTotal, remainingPayAmount) {
    if (returnedTotal > remainingPayAmount) {
        return 'priceExceedsOriginal';
    }
    return undefined;
}
function validateAllRefundItems(editableItems, orderDetail, refundType = 'quantity') {
    const lineErrors = new Map();
    let isValid = true;
    const refundTotal = editableItems.reduce((total, item) => {
        const returnedAmount = item.returnedAmount ?? 0;
        const returnedPrice = item.returnedPrice ?? 0;
        return total + returnedAmount * returnedPrice;
    }, 0);
    const totalAmountError = validateRefundAmount(refundTotal, orderDetail.taxedAmount);
    if (totalAmountError) {
        isValid = false;
    }
    const refundableItems = (0, refundHelpers_1.computeRefundableItems)(orderDetail.orderItems);
    editableItems.forEach((item) => {
        const refundableItem = refundableItems.find((ri) => ri.aisleCode === item.aisleCode);
        if (refundableItem) {
            if (refundType === 'quantity') {
                const returnedAmount = item.returnedAmount ?? 0;
                const quantityError = validateLineQuantity(returnedAmount, refundableItem.amount, item.aisleCode);
                if (quantityError) {
                    lineErrors.set(item.aisleCode, quantityError);
                    isValid = false;
                }
            }
            else {
                const returnedTotal = item.returnedTotal ?? 0;
                const priceError = validateLinePriceTotal(returnedTotal, refundableItem.payAmount);
                if (priceError) {
                    lineErrors.set(item.aisleCode, priceError);
                    isValid = false;
                }
            }
        }
    });
    return {
        isValid,
        totalAmountError,
        lineErrors,
    };
}
